import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Banner, Typography } from '@getgo/chameleon-web-react-wrapper';

const isSafeUrl = (value) => typeof value === 'string' && /^https:\/\//i.test(value);

const NudgeBanner = ({ variant, messageKey, url, linkLabel, className, closable }) => {
  const [dismissed, setDismissed] = useState(false);

  if (!isSafeUrl(url) || dismissed) {
    return null;
  }

  return (
    <Banner
      data-testid="nudge-banner"
      variant={variant}
      className={className}
      closable={closable}
      onClose={() => setDismissed(true)}
    >
      <Typography>
        <FormattedMessage {...messageKey} />{' '}
        <a href={url} target="_blank" rel="noopener noreferrer">
          <FormattedMessage {...linkLabel} />
        </a>.
      </Typography>
    </Banner>
  );
};

NudgeBanner.propTypes = {
  variant: PropTypes.oneOf(['marketing', 'success', 'neutral', 'danger']),
  messageKey: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
  }).isRequired,
  url: PropTypes.string,
  linkLabel: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
  closable: PropTypes.bool,
};

NudgeBanner.defaultProps = {
  variant: 'marketing',
  url: undefined,
  className: undefined,
  closable: false,
};

export default NudgeBanner;
